module.exports = __webpack_public_path__ + "7956966a80ad0dde3638c8cfc9d494e8.svg";